var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdkIconPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFC",
    d: "M0 0H16V16H0z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E20074",
    d: "M15.146 4.513L8.234 1.548c-.149-.064-.317-.064-.465 0L.857 4.513C.64 4.606.5 4.819.5 5.055c0 .236.141.449.358.541l6.913 2.946c.073.031.152.047.23.047.08 0 .158-.016.231-.047l6.913-2.946c.217-.092.358-.305.358-.541 0-.236-.14-.45-.357-.542zM8.001 7.36L2.588 5.053 8 2.73l5.414 2.323L8.002 7.36zM15.456 10.714c-.129-.3-.476-.438-.774-.31l-6.68 2.866-6.68-2.865c-.3-.13-.646.01-.774.309-.128.298.01.645.309.773l6.912 2.966c.075.031.154.047.233.047.079 0 .158-.016.232-.047l6.912-2.966c.3-.128.438-.475.31-.773z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E20074",
    d: "M15.456 7.77c-.128-.3-.474-.439-.773-.312l-6.681 2.848L1.32 7.458c-.3-.127-.645.012-.773.311-.127.3.012.646.311.773l6.913 2.946c.073.031.152.047.23.047.08 0 .158-.016.231-.047l6.913-2.946c.3-.127.438-.473.31-.773z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdkIconPink);
export default __webpack_public_path__ + "static/media/sdkIconPink.07a1f6b728971bc0caedb8879e9f4089.svg";
export { ForwardRef as ReactComponent };